<div class="p-2">
    <div class="header d-flex align-items-center justify-content-between mx-2 my-3">
        <span>Vizualizare Matricole selectate</span>
        <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="col-sm-12 mt-3">
        <table class="table">
            <thead>
                <tr>
                    <th>Nr. Matricolă</th>
                    <th>Tip Matricolă</th>
                    <th>Adresa</th>
                    <th>Descriere</th>
                </tr>
            </thead>  
            <tbody>
                <tr *ngFor="let row of filteredMatricole">
                    <td>{{ row.matricola }}</td>
                    <td>{{ row.numeTip }}</td>
                    <td>{{ row.adresa }}</td>
                    <td>{{ row.descriere }}</td>
                </tr>
            </tbody>   
        </table>
    </div>
    <div class="col-sm-12">
        <span>Nr. de <strong>{{ data.matricole_arr.length }}</strong> Matricole din totalul de: <strong>{{ data.matricole_json.length }} Matricole disponibile</strong></span>
    </div>
    <div class="footer mt-2 mb-4">
        <button type="button" class="btn btn-md btn-warning" (click)="closeDialog()">Închide</button>
    </div>
</div>